export default [
  { title: 'Logolarimiz', to: '/enterprise' },
  { title: 'Banka Hesaplari', to: '/enterprise' },
  { title: 'İletişim', to: '/enterprise' },
  { title: 'Cari Bilgilerimiz', to: '/enterprise' },
 
];
